import { AppLogo } from '@/assets/icons/AppLogo';
import { MEADOW_SCENE } from '@/components/blocks/auth/meadow-scene';
import { userStore } from '@/stores/user.store';
import { inBrowser } from '@/utils/capabilities';

import { DownloadButton } from './download-button';

/**
 * Web-only "Meadow" treatment: insets the whole app inside the painterly login
 * backdrop, leaving a thin border of meadow around the app and a taller strip
 * along the top that carries the download call-to-action. It renders the app
 * untouched outside the browser and for users already onboarded on desktop.
 */
export const MeadowAppFrame = ({ children }: { children: React.ReactNode }) => {
  if (!inBrowser() || userStore.isOnboarded) {
    return <>{children}</>;
  }

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#1B1C15]">
      <img
        src={MEADOW_SCENE.imageUrl}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
        style={{ objectPosition: MEADOW_SCENE.objectPosition }}
      />
      <div
        className="absolute inset-0"
        style={{ background: MEADOW_SCENE.wash }}
      />

      <div className="relative z-10 flex h-full w-full flex-col">
        <MeadowDownloadHeader />
        <div className="min-h-0 flex-1 px-2.5 pb-2.5">
          <div className="h-full w-full overflow-hidden rounded-2xl border border-white/40 bg-background shadow-[0_30px_80px_-24px_rgba(27,28,21,0.6)]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

const MeadowDownloadHeader = () => {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-center gap-x-4 gap-y-1.5 px-4 py-2.5">
      <div className="flex items-center gap-2.5 min-w-0">
        <AppLogo size={18} customColor="#FFFAEB" />
        <span className="truncate text-[13.5px] text-[#FFFAEB]/95 [text-shadow:0_1px_6px_rgba(27,28,21,0.45)]">
          Download the desktop app to record meetings, capture context, and get
          smarter answers.
        </span>
      </div>
      <DownloadButton variant="paper" size="sm" />
    </div>
  );
};
